'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerSlot = registerSlot;
exports.defineSlot = defineSlot;
exports.displayAd = displayAd;
exports.displayAdsAboveTheFold = displayAdsAboveTheFold;
exports.increaseSequence = increaseSequence;
exports.addSettings = addSettings;
exports.addEnv = addEnv;
exports.addRequestParams = addRequestParams;
exports.addContentType = addContentType;
exports.nativeCalled = nativeCalled;

var _actionTypes = require('./action-types');

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Register Slot action
 * @param {Object} props from component
 * @returns {Object}
 */
function registerSlot(props) {
  return {
    type: types.REGISTER_SLOT,
    props: props
  };
}

/**
 * Register Define Slot
 * @param {string} id from component
 * @param {Object} slot defined
 * @returns {Object}
 */
function defineSlot(id, slot) {
  return {
    type: types.DEFINE_SLOT,
    id: id,
    slot: slot
  };
}

/**
 * Display ad action
 * @param {string} id from component
 * @returns {Object}
 */
function displayAd(id) {
  return {
    type: types.DISPLAY_AD,
    id: id
  };
}

/**
 * Display above the fold action
 * @returns {Object}
 */
function displayAdsAboveTheFold() {
  return {
    type: types.DISPLAY_ADS_ABOVE_THE_FOLD
  };
}

/**
 * Increase order of ad calls
 * @returns {Object}
 */
function increaseSequence() {
  return {
    type: types.INCREASE_SEQUENCE
  };
}

/**
 * Add settings
 * @param {Object} settings from api
 * @returns {Object}
 */
function addSettings(settings) {
  return {
    type: types.ADD_SETTINGS,
    settings: settings
  };
}

/**
 * Add running environment
 * @param {string} env where the app is running
 * @returns {Object}
 */
function addEnv(env) {
  return {
    type: types.ADD_ENV,
    env: env
  };
}

/**
 * Add request parameters
 * @param {Object} requestParams from api
 * @returns {Object}
 */
function addRequestParams(requestParams) {
  return {
    type: types.ADD_REQUEST_PARAMS,
    requestParams: requestParams
  };
}

/**
 * Add content type
 * @param {string} contentType of the page
 * @returns {Object}
 */
function addContentType(contentType) {
  return {
    type: types.ADD_CONTENT_TYPE,
    contentType: contentType
  };
}

/**
 * Add native add call flag
 * @returns {Object}
 */
function nativeCalled() {
  return {
    type: types.SET_NATIVE
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/store/actions/ads-actions.js
// module id = 156
// module chunks = 35783957827783